import React, { useRef, useState } from 'react'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import Footer from '../../components/Footer'
import { PrimaryButton } from '../../components/StyledButtons'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import example_invoice from "../../assets/images/contents/invoices-and-bills-1.png"
import qrypto_generating from "../../assets/images/contents/invoices-and-bills-2.png"
import filter_color from "../../assets/images/design/colorFilter.svg"
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'


const InvoicesAndBills = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [mousePosition1, setMousePosition1] = useState({ x: 0, y: 0 });

    const [mousePosition2, setMousePosition2] = useState({ x: 0, y: 0 });

    const handleMouseMove1 = (e) => {
        setMousePosition1({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY });
    };

    const handleMouseMove2 = (e) => {
        setMousePosition2({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY });
    };

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='invoices-and-bills bg-primary'>
            <div className='color-filter-right' style={{ top: "20%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "52%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid invoices-and-bills-header pb-100'>

                <div className='container'>

                    {language === "en" ?
                        <div className='col-sm-12 pt-150'>
                            <p className='font-weight-bold text-center font-64 invoices-and-bills-header-title'>INVOICES & BILLS</p>
                            <div className='col-sm-10 col-sm-offset-1 '>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                        :
                        <div className='col-sm-10 col-sm-offset-1 pt-150'>
                            <p className='font-weight-bold text-center font-64 invoices-and-bills-header-title'>HÓA ĐƠN & BIÊN LAI</p>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                    }
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.invoices-and-bills')} linkToPrevPage="/industries" />
                    </div>
                </div>
            </div>
            <div className='invoices-and-bills-content container'>
                <div className='row flex-lg'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu generalActive={true} invoicesAndBillsActive={true} />
                    </div>
                    <div className='col-lg-w--400 invoices-and-bills-content_info'>
                        <p className='font-48 font-weight-semibold text-white'>{t('invoices-and-bills.title')}</p>
                        <p className='text-white pt-20 font-weight-medium font-20'>{t('invoices-and-bills.sub-title')}</p>
                        <p className='text-white pt-20'>{t('invoices-and-bills.content-1')}</p>
                        <p className='text-white'>{t('invoices-and-bills.content-2')}</p>
                        <p className='text-white pt-50 font-weight-medium font-20'>{t('invoices-and-bills.question')}</p>
                        <ol className='text-white pt-20'>
                            <li>{t('invoices-and-bills.ans-1')}</li>
                            <li>{t('invoices-and-bills.ans-2')}</li>
                            <li>{t('invoices-and-bills.ans-3')}</li>
                            <li>{t('invoices-and-bills.ans-4')}</li>
                            <li>{t('invoices-and-bills.ans-5')}</li>
                            <li>{t('invoices-and-bills.ans-6')}</li>
                        </ol>

                        <div className='col-sm-12 px-0 pt-50'>
                            <div className='invoices-card-pink' onMouseMove={handleMouseMove1}>
                                <div className='blur-red' style={{
                                    left: mousePosition1.x - 950 + 'px',
                                    top: mousePosition1.y - 600 + 'px'
                                }} />
                                <div className='row'>

                                    <div className='col-sm-12 col-md-5 index-10'>
                                        <div className='flex justify-center'>
                                            <img src={example_invoice} alt="" className='img-responsive' />
                                        </div>
                                    </div>

                                    <div className='col-sm-12 col-md-7 pl-30 index-10'>
                                        <p className='font-27 pt-150 pr-md-20 font-weight-medium'>{t('invoices-and-bills.card-title-1')}</p>
                                        <p className='pt-40'>{t('invoices-and-bills.card-content-1')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='col-sm-12 mt-50 px-0'>
                            <div className="invoices-card-blue" onMouseMove={handleMouseMove2}>
                                <div className='blur-white' style={{
                                    left: mousePosition2.x - 1000 + 'px',
                                    top: mousePosition2.y - 300 + 'px'
                                }} />
                                <div className='row'>
                                    <div className='col-sm-12 col-md-5 index-10'>
                                        <p className='font-27 pt-70 pb-30 text-white font-weight-medium'>{t('invoices-and-bills.card-title-2')}</p>
                                    </div>
                                    <div className='col-sm-12 col-md-7 index-10'>
                                        <div className='flex justify-center invoices-card-pink-mini'>
                                            <img src={qrypto_generating} alt="" className='img-responsive' />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 index-10">
                                        <p className='text-white font-20 font-weight-medium pt-50'>{t('invoices-and-bills.card-content-2')}</p>
                                        <ul className='list-unstyled pt-20'>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-1')}</li>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-2')}</li>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-3')}</li>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-4')}</li>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-5')}</li>
                                            <li className='checked-line'>{t('invoices-and-bills.card-content-2-6')}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <PrimaryButton
                                onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.schedule-discussion')}</PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>
            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default InvoicesAndBills